<template>
  <div class="modalContent">
    <div class="modalHeader d-flex justify-content-between">
      <div class="titleGraph align-self-top">
        {{ $t('historico') }} {{ nodeSelected.indicatorNameSelect }}
      </div>
      <div class="loadingData">
        <img src="@/assets/loading2.gif" style="max-height: 54px;
                    position: relative;
                    left: calc(50% - 27px);
                    top: calc(50% - 27px);" 
                    :title="$t('aguardando-dados')" 
                    :alt="$t('aguardando-dados')" /> 
      </div>
      <div class="groupBtn d-flex justify-content-end align-items-center">
        <div class="datepicker-input-group">
          <search-date-picker 
            :lang="search.datePicker.ptbr"
            :shortcuts="search.datePicker.shortcuts"
            v-model="search.datePicker.customInterval"
            class="custom-date"
            type="datetime"
            format="DD/MM/YYYY HH:mm"
            range
            placeholder="Intervalo da busca"
            range-separator="  até  ">
            <template v-slot:input="slotProps">
              <input type="text" v-bind="slotProps.props" v-on="slotProps.events" />
            </template>

            <template v-slot:icon-calendar>
              <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                <path d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
              </svg>
            </template>
          </search-date-picker>
        </div>
        <div class="search-button-group-img ml-2 mr-1">
          <img v-if="!loadtrendExecuting" @click="onClick_Search" src="@/assets/buscar.png" :title="$t('pesquisar-0')" style="width: 30px; height: 30px" />
          <span v-else class="spinner-border spinner-border-sm spinnerConfig" role="status" aria-hidden="true" :title="$t('por-favor-aguarde-o-carregamento')"></span>
        </div>
        <div class="filterGroup" v-if="filterRenderToggle">
          <span class="filterLabel">{{ $t('filtro-0') }}</span>
          <b-form-input class="input-pentagro" id="filterRender" v-model="filterValue" @change="isGreaterThanHundread"
            type="number" number="true" min="0" max="100"></b-form-input>
          <b-button class="filterBt" @click="loadData">{{ $t('ok-0') }}</b-button>
        </div>
        <img
          v-if="user.Permissions.criarocorrencia && user.Permissions.criarocorrencia.allowed && nodeSelected.keySelect.includes('KG')"
          id="filterIcon" v-b-modal.newOccurenceByTrend class="float-right" src="@/assets/ocorrencia2.png"
          style="max-height: 25px; padding-right: 10px" 
          :title="$t('criar-ocorrencia')" 
          :alt="$t('criar-ocorrencia')" />
        <span v-if="filterFlag == 0">
          <img class="ml-2 printer-button" src="@/assets/atualizar.png" style="max-height: 30px; padding-right: 10px"
            :alt="$t('atualizar-graficos')" 
            :title="$t('atualizar-graficos')" 
            @click="ReloadData" />
          <img id="filterIcon" class="float-right" src="@/assets/filtro2.png"
            style="max-height: 30px; padding-right: 10px" 
            :title="$t('ativar-desativar-filtro')"
            @click="filterRenderOption"
            :alt="$t('ativar-desativar-filtro-0')" />
        </span>
        <span v-if="filterFlag == 1">
          <img id="filterIcon" class="float-right" src="@/assets/filtro1.png"
            style="max-height: 30px; padding-right: 10px" 
            :title="$t('ativar-desativar-filtro')" 
            @click="filterRenderOption"
            :alt="$t('ativar-desativar-filtro-0')" />
        </span>
        <img style="max-height: 30px; padding-right: 10px" id="1Day" class="float-right" src="@/assets/comparakpi.png"
          :title="$t('comparar-indicadores')" :alt="$t('compara-kpi')" @click="showCompareKPI" />
        <img id="closeModal" class="float-right" src="@/assets/sair.png" style="max-height: 35px" :title="$t('sair')"
          :alt="$t('sair')" @click="onCloseModal" />
      </div>
    </div>
    <div class="gridColumns">
      <div class="gridGraphStyle1" v-show="this.compareKPI">
        <div class="comboboxField">
          <div>
            <div class="comboHeader">
              <span>{{ $t('indicador-1') }}</span>
              <b-form-checkbox v-model="scaleKey1" name="scaleKey1" :disabled="this.switchKey1Options" switch>{{ $t('escalonar') }}
              </b-form-checkbox>
            </div>
            <template>
              <select class="form-control" v-model="key1">
                <option v-for="(indicator, i) in this.indicators" :key="i" :value="indicator.key">{{
                indicator.indicatorName }}</option>
              </select>
            </template>
          </div>
          <div>
            <div class="comboHeader">
              <span>{{ $t('indicador-2') }}</span>
              <b-form-checkbox v-model="scaleKey2" name="scaleKey2" :disabled="this.switchKey2Options" switch>{{ $t('escalonar') }}
              </b-form-checkbox>
            </div>
            <template>
              <select class="form-control" v-model="key2">
                <option v-for="(indicator, i) in this.indicators" :key="i" :value="indicator.key">{{
                indicator.indicatorName }}</option>
              </select>
            </template>
          </div>
          <div>
            <div class="comboHeader">
              <span>{{ $t('indicador-3') }}</span>
              <b-form-checkbox v-model="scaleKey3" name="scaleKey3" :disabled="this.switchKey3Options" switch>{{ $t('escalonar') }}
              </b-form-checkbox>
            </div>
            <template>
              <select class="form-control" v-model="key3">
                <option v-for="(indicator, i) in this.indicators" :key="i" :value="indicator.key">{{
                indicator.indicatorName }}</option>
              </select>
            </template>
          </div>
        </div>
        <div class="rto-trend-wrapper" @mouseleave="onTrendMouseLeave">
          <apexcharts class="trendPosition" :options="chartOptions1" height="230" :series="trendKPICorrelation.series">
          </apexcharts>
          <div v-if="rtoTooltip.visible" class="rto-period-tooltip" :style="{ left: rtoTooltip.x + 'px', background: rtoTooltip.color }">{{ rtoTooltip.name }}</div>
        </div>
      </div>
      <div class="gridGraphStyle2" v-show="!this.compareKPI">
        <apexcharts :options="meanChart" width="100%" height="230px" :series="meanChart.series"></apexcharts>
        <apexcharts :options="ppkChart" width="100%" height="230px" :series="ppkChart.series"></apexcharts>
        <apexcharts :options="reabilityChart" width="100%" height="230px" :series="reabilityChart.series"></apexcharts>
        <div class="rto-trend-wrapper" @mouseleave="onTrendMouseLeave">
          <apexcharts class="trendPosition" :options="chartOptions1" height="230" :series="trend.series"></apexcharts>
          <div v-if="rtoTooltip.visible" class="rto-period-tooltip" :style="{ left: rtoTooltip.x + 'px', background: rtoTooltip.color }">{{ rtoTooltip.name }}</div>
          <b-modal id="newOccurenceByTrend" size="xl" hide-footer :title="$t('criar-ocorrencia-1')" :no-close-on-backdrop="true">
            <newOccurrence :keyByTrend="nodeSelected.keySelect"></newOccurrence>
          </b-modal>
        </div>
      </div>
    </div>
    <hr class="mobile-mode" />
  </div>
</template>

<script>
import searchDatePicker from 'vue2-datepicker';
import ptbr from 'vue2-datepicker/locale/pt-br'
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
import newOccurrence from "../../occurrence/newOccurrence.vue"
import * as moment from "moment";
import "moment/locale/pt-br";
import { mapState } from "vuex";
//import { index } from "d3";

let that;

export default {
  props: {
    nodeSelected: Object,
    onCloseModal: Function,
  },

  computed: mapState(["user"]),

  components: {
    apexcharts: VueApexCharts, newOccurrence, searchDatePicker
  },

  data: function () {
    const vm = this;
    return {
      agregation: '',
      loadtrendCorrelationExecuting: false,
      loadtrendExecuting: false,
      compareKPI: false,
      indicators: [{ indicatorName: this.$t('selecione-um-indicador'), key: null }],
      listValues: {},
      system: "",
      key1: null,
      key2: null,
      key3: null,
      scaleKey1: false,
      scaleKey2: false,
      scaleKey3: false,
      switchKey1Options: true,
      switchKey2Options: true,
      switchKey3Options: true,
      filterFlag: 0,
      filterValue: 0,
      filterRenderToggle: false,
      startDate: null,
      finalDate: null,
      modalOpen: true,
      storagedStartDate: "",
      storagedFinalDate: "",

      rtoTooltip: { visible: false, x: 0, name: '', color: '#f97316' },
      rtoPeriodLines: [],
      rtoInativoBands: [],

      chartOptions1: {
        chart: {
          id: "area-datetime",
          defaultLocale: "pt-BR",
          locales: [
            {
              name: "pt-BR",
              options: {
                months: [
                  this.$t('janeiro'),
                  this.$t('fevereiro'),
                  this.$t('marco'),
                  this.$t('abril'),
                  this.$t('maio'),
                  this.$t('junho'),
                  this.$t('julho'),
                  this.$t('agosto'),
                  this.$t('setembro'),
                  this.$t('outubro'),
                  this.$t('novembro'),
                  this.$t('dezembro'),
                ],
                shortMonths: [
                  this.$t('jan'),
                  this.$t('fev'),
                  this.$t('mar'),
                  this.$t('abr'),
                  this.$t('mai'),
                  this.$t('jun'),
                  this.$t('jul'),
                  this.$t('ago'),
                  this.$t('set'),
                  this.$t('out'),
                  this.$t('nov'),
                  this.$t('dez'),
                ],
                days: [
                  this.$t('domingo'),
                  this.$t('segunda'),
                  this.$t('terca'),
                  this.$t('quarta'),
                  this.$t('quinta'),
                  this.$t('sexta'),
                  this.$t('sabado'),
                ],
                shortDays: [this.$t('dom'), this.$t('seg'), this.$t('ter'), this.$t('qua'), this.$t('qui'), this.$t('sex'), this.$t('sab')],
                toolbar: {
                  exportToSVG: this.$t('download-svg'),
                  exportToPNG: this.$t('download-png'),
                  exportToCSV: this.$t('download-csv'),
                  menu: this.$t('menu'),
                  selection: this.$t('selecionar'),
                  selectionZoom: this.$t('zoom-de-selecao'),
                  zoomIn: this.$t('aumentar-zoom'),
                  zoomOut: this.$t('diminuir-zoom'),
                  pan: this.$t('panoramica'),
                  reset: this.$t('restaurar-zoom'),
                },
              },
            },
          ],
          type: "line",
          stacked: false,
          zoom: {
            autoScaleYaxis: true,
          },
          events: {
            mouseMove(event, chartContext, { globals }) {
              if (!vm.rtoPeriodLines.length) return;
              const { translateX: gridLeft, gridWidth, minX, maxX } = globals;
              if (!gridWidth || !maxX || maxX <= minX) return;
              const chartRect = chartContext.el.getBoundingClientRect();
              const px = event.clientX - chartRect.left - gridLeft;
              if (px < 0 || px > gridWidth) { vm.rtoTooltip.visible = false; return; }
              const totalMs = maxX - minX;
              const cursorMs = minX + (px / gridWidth) * totalMs;
              const thresholdMs = (15 / gridWidth) * totalMs;
              const tooltipX = event.clientX - chartRect.left;
              const hitLine = vm.rtoPeriodLines.find(p => Math.abs(p.startMs - cursorMs) < thresholdMs);
              const hitBand = !hitLine && vm.rtoInativoBands.find(b => cursorMs >= b.startMs && cursorMs <= b.endMs);
              const hit = hitLine || hitBand;
              vm.rtoTooltip = hit
                ? { visible: true, x: tooltipX, name: hit.name, color: hitLine ? '#f97316' : '#6b7280' }
                : { visible: false, x: 0, name: '', color: '#f97316' };
            },
          },
        },

        colors: ["#660000", "#004c26", "#ff9a2e", "#800080", "#0000ff"],


        yaxis: {
          labels: {
            // eslint-disable-next-line no-unused-vars
            formatter: function (num, opts) {
              if (!isNaN(parseFloat(num))) {
                var numParsed = parseFloat(num);
                if (
                  (numParsed > 0 && numParsed < 1) ||
                  (numParsed < 0 && numParsed > -1)
                ) {
                  numParsed = numParsed.toFixed(4);
                } else {
                  numParsed = numParsed.toFixed(3);
                }

                numParsed = numParsed.replace(".", ",").split(",");

                let v1 = numParsed[0];
                let v2 = numParsed[1];
                v1 = v1.split("").reverse();
                let i = 0;
                var stop = 0;

                if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                  i = 1;
                  stop = Math.trunc(v1.length / 3);
                }

                if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                  i = 1;
                  stop = Math.trunc(v1.length / 3) - 1;
                }

                var pos = 3;

                if (i >= 1) {
                  for (i; i <= stop; i++) {
                    v1.splice(pos, 0, ".");
                    pos = pos + 4;
                  }
                }

                numParsed = v1.reverse().join("") + "," + v2;

                if (numParsed.includes("-.")) {
                  numParsed = numParsed.replace("-.", "-");
                }
                return numParsed;
              }
              return null;
            },

            showForNullSeries: false,
            seriesName: "Valor",
            tickAmount: 6,

            min: function (min) {
              return min;
            },
            max: function (max) {
              return max;
            },
            forceNiceScale: true,
            decimalsInFloat: 3,
          },
          annotations: {
            yaxis: [],
            xaxis: [],
          },

          noData: {
            text: this.$t('sem-dados'),
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "14px",
              fontFamily: undefined,
            },
          },
          dataLabels: {
            enabled: true,
          },
        },

        markers: {
          size: 0,
          showNullDataPoints: true,
          hover: {
            sizeOffset: 4,
          },
          style: "hollow",
        },

        stroke: {
          width: [2, 2, 2, 2],
          dashArray: [0, 0, 0, 0],
        },

        xaxis: {
          type: "datetime",
          min: this.startDate,
          max: this.finalDate,
          tickAmount: 6,
          tooltip: {
            enabled: false,
          },
          labels: {
            datetimeUTC: false,
          }
        },

        legend: {
          show: true,
          showForNullSeries: false,
        },

        tooltip: {
          enabled: true,
          shared: true,
          x: {
            show: false,
          },
          // eslint-disable-next-line no-unused-vars
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let label = w.config.series[seriesIndex].name;
            let labelColor = w.config.colors[seriesIndex];
            let numParsed = w.config.series[seriesIndex].data[dataPointIndex].z;
            let datePoint = new Date(
              w.config.series[seriesIndex].data[dataPointIndex].x
            );
            datePoint = datePoint.toLocaleString("pt-BR");
            if (!isNaN(parseFloat(numParsed))) {
              numParsed = parseFloat(numParsed);
              if (
                (numParsed > 0 && numParsed < 1) ||
                (numParsed < 0 && numParsed > -1)
              ) {
                numParsed = numParsed.toFixed(4);
              } else {
                numParsed = numParsed.toFixed(3);
              }
              numParsed = numParsed.replace(".", ",").split(",");
              let v1 = numParsed[0];
              let v2 = numParsed[1];
              v1 = v1.split("").reverse();
              let i = 0;
              var stop = 0;
              if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                i = 1;
                stop = Math.trunc(v1.length / 3);
              }
              if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                i = 1;
                stop = Math.trunc(v1.length / 3) - 1;
              }
              var pos = 3;
              if (i >= 1) {
                for (i; i <= stop; i++) {
                  v1.splice(pos, 0, ".");
                  pos = pos + 4;
                }
              }
              numParsed = v1.reverse().join("") + "," + v2;
              if (numParsed.includes("-.")) {
                numParsed = numParsed.replace("-.", "-");
              }
            }
            else {
              numParsed = that.$t('sem-dados');
            } 

            return (
              '<div class="arrow_box" style="padding: 10px;">' +
              '<div class="date-box"><b>' +
              datePoint +
              "</b></div>" +
              '<div class="label-box"><span style="margin-right: 5px;color:' +
              labelColor +
              ';">&#11044</span><span>' +
              label +
              ": " +
              numParsed +
              "</span></div>" +
              "</div>"
            );
          },
        },
      },

      trend: {
        series: [],
      },

      trendKPICorrelation: {
        series: [],
      },

      meanChart: {
        chart: {
          type: "bar",
        },

        plotOptions: {
          bar: {
            columnWidth: "85%",
          },
        },

        title: {
          text: this.$t('media'),
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },

        dataLabels: {
          enabled: true,
          // eslint-disable-next-line no-unused-vars
          formatter: function (num, { seriesIndex, dataPointIndex, w }) {
            if (w.config.series[0].data.length > 1) {
              return ''
            }
            if (!isNaN(parseFloat(num))) {
              var numParsed = parseFloat(num);
              if (numParsed >= 1000000 || numParsed <= -1000000)
                return numParsed.toExponential(3);
              if (
                (numParsed > 0 && numParsed < 1) ||
                (numParsed < 0 && numParsed > -1)
              ) {
                numParsed = numParsed.toFixed(4);
              } else {
                numParsed = numParsed.toFixed(2);
              }
              numParsed = numParsed.replace(".", ",").split(",");
              let v1 = numParsed[0];
              let v2 = numParsed[1];
              v1 = v1.split("").reverse();
              let i = 0;
              var stop = 0;
              if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                i = 1;
                stop = Math.trunc(v1.length / 3);
              }
              if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                i = 1;
                stop = Math.trunc(v1.length / 3) - 1;
              }
              var pos = 3;
              if (i >= 1) {
                for (i; i <= stop; i++) {
                  v1.splice(pos, 0, ".");
                  pos = pos + 4;
                }
              }
              numParsed = v1.reverse().join("") + "," + v2;
              if (numParsed.includes("-.")) {
                numParsed = numParsed.replace("-.", "-");
              }
              return numParsed;
            }
            return;
          },
          style: {
            fontSize: "8px",
          },
        },

        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },

        yaxis: {
          labels: {
            // eslint-disable-next-line no-unused-vars
            formatter: function (num, opts) {
              if (!isNaN(parseFloat(num))) {
                var numParsed = parseFloat(num);
                if (numParsed >= 1000000 || numParsed <= -1000000)
                  return numParsed.toExponential(3);
                if (
                  (numParsed > 0 && numParsed < 1) ||
                  (numParsed < 0 && numParsed > -1)
                ) {
                  numParsed = numParsed.toFixed(4);
                } else {
                  numParsed = numParsed.toFixed(2);
                }
                numParsed = numParsed.replace(".", ",").split(",");
                let v1 = numParsed[0];
                let v2 = numParsed[1];
                v1 = v1.split("").reverse();
                let i = 0;
                var stop = 0;
                if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                  i = 1;
                  stop = Math.trunc(v1.length / 3);
                }
                if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                  i = 1;
                  stop = Math.trunc(v1.length / 3) - 1;
                }
                var pos = 3;
                if (i >= 1) {
                  for (i; i <= stop; i++) {
                    v1.splice(pos, 0, ".");
                    pos = pos + 4;
                  }
                }
                if (parseFloat(numParsed) >= 1000 || parseFloat(numParsed) <= -1000) {
                  numParsed = v1.reverse().join("")
                }
                else {
                  numParsed = v1.reverse().join("") + "," + v2;
                }
                if (numParsed.includes("-.")) {
                  numParsed = numParsed.replace("-.", "-");
                }
                return numParsed;
              }
              return;
            },
            style: {
              fontSize: "11px",
            },
          },
        },

        tooltip: {
          enabled: true,
          y: {
            show: true,
            // eslint-disable-next-line no-unused-vars
            formatter: function (num, { seriesIndex, dataPointIndex, w }) {
              if (!isNaN(parseFloat(num))) {
                var numParsed = parseFloat(num);
                if (numParsed >= 1000000 || numParsed <= -1000000)
                  return numParsed.toExponential(3);
                if (
                  (numParsed > 0 && numParsed < 1) ||
                  (numParsed < 0 && numParsed > -1)
                ) {
                  numParsed = numParsed.toFixed(4);
                } else {
                  numParsed = numParsed.toFixed(3);
                }
                numParsed = numParsed.replace(".", ",").split(",");
                let v1 = numParsed[0];
                let v2 = numParsed[1];
                v1 = v1.split("").reverse();
                let i = 0;
                var stop = 0;
                if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                  i = 1;
                  stop = Math.trunc(v1.length / 3);
                }
                if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                  i = 1;
                  stop = Math.trunc(v1.length / 3) - 1;
                }
                var pos = 3;
                if (i >= 1) {
                  for (i; i <= stop; i++) {
                    v1.splice(pos, 0, ".");
                    pos = pos + 4;
                  }
                }
                numParsed = v1.reverse().join("") + "," + v2;
                if (numParsed.includes("-.")) {
                  numParsed = numParsed.replace("-.", "-");
                }
                return numParsed;
              }
              return;
            },
          },

          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: 0,
            offsetY: 0,
          }
        },
        legend: {
          show: false,
        },

        colors: ["#660000", "#004c26"],
        series: [],
      },

      ppkChart: {
        chart: {
          type: "bar",
        },
        title: {
          text: this.$t('ppk'),
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },

        dataLabels: {
          enabled: true,
          // eslint-disable-next-line no-unused-vars
          formatter: function (num, { seriesIndex, dataPointIndex, w }) {
            if (w.config.series[0].data.length > 1) {
              return ''
            }
            if (!isNaN(parseFloat(num))) {
              var numParsed = parseFloat(num);
              if (
                (numParsed > 0 && numParsed < 1) ||
                (numParsed < 0 && numParsed > -1)
              ) {
                numParsed = numParsed.toFixed(4);
              } else {
                numParsed = numParsed.toFixed(3);
              }
              numParsed = numParsed.replace(".", ",").split(",");
              let v1 = numParsed[0];
              let v2 = numParsed[1];
              v1 = v1.split("").reverse();
              let i = 0;
              var stop = 0;
              if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                i = 1;
                stop = Math.trunc(v1.length / 3);
              }
              if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                i = 1;
                stop = Math.trunc(v1.length / 3) - 1;
              }
              var pos = 3;
              if (i >= 1) {
                for (i; i <= stop; i++) {
                  v1.splice(pos, 0, ".");
                  pos = pos + 4;
                }
              }
              numParsed = v1.reverse().join("") + "," + v2;
              if (numParsed.includes("-.")) {
                numParsed = numParsed.replace("-.", "-");
              }
              return numParsed;
            }
            return;
          },
          style: {
            fontSize: "8px",
          },
        },

        xaxis: {
          labels: {
            style: {
              fontSize: "11px",
            },
          },
        },

        yaxis: {
          labels: {
            // eslint-disable-next-line no-unused-vars
            formatter: function (num, opts) {
              if (!isNaN(parseFloat(num))) {
                var numParsed = parseFloat(num);
                if (
                  (numParsed > 0 && numParsed < 1) ||
                  (numParsed < 0 && numParsed > -1)
                ) {
                  numParsed = numParsed.toFixed(4);
                } else {
                  numParsed = numParsed.toFixed(3);
                }
                numParsed = numParsed.replace(".", ",").split(",");
                let v1 = numParsed[0];
                let v2 = numParsed[1];
                v1 = v1.split("").reverse();
                let i = 0;
                var stop = 0;
                if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                  i = 1;
                  stop = Math.trunc(v1.length / 3);
                }
                if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                  i = 1;
                  stop = Math.trunc(v1.length / 3) - 1;
                }
                var pos = 3;
                if (i >= 1) {
                  for (i; i <= stop; i++) {
                    v1.splice(pos, 0, ".");
                    pos = pos + 4;
                  }
                }
                numParsed = v1.reverse().join("") + "," + v2;
                if (numParsed.includes("-.")) {
                  numParsed = numParsed.replace("-.", "-");
                }
                return numParsed;
              }
              return;
            },
          },
          noData: {
            text: this.$t('sem-dados'),
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "11px",
              fontFamily: undefined,
            },
          },
        },
        colors: ["#660000"],
        series: [],
      },

      reabilityChart: {
        chart: {
          type: "bar",
        },
        title: {
          text: this.$t('aderencia-0'),
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },
        dataLabels: {
          enabled: true,
          // eslint-disable-next-line no-unused-vars
          formatter: function (num, { seriesIndex, dataPointIndex, w }) {
            if (w.config.series[0].data.length > 1) {
              return ''
            }
            return (num * 100).toFixed(2) + "%";
          },
          style: {
            fontSize: "8px",
          },
        },
        xaxis: {
          labels: {
            style: {
              fontSize: "11px",
            },
          },
        },
        yaxis: {
          min: 0,
          max: 1,
          labels: {
            // eslint-disable-next-line no-unused-vars
            formatter: function (num, opts) {
              return (num * 100).toFixed(2) + "%";
            },
          },
        },
        colors: ["#660000"],
        series: [],
      },

      search: {
        datePicker: {
          ptbr: {
            ...ptbr,
            monthFormat: 'MMMM'
          },
          customInterval: [],
          shortcuts: [{
            text: 'Hoje',
            onClick: () => {
              this.search.datePicker.customInterval = [new Date(), new Date()];
              console.log('>> ', 'opa', this.search.datePicker.customInterval)
            }
          },
          {
            text: '2 dias',
            onClick: () => {
              let two = new Date();
              two.setDate(two.getDate() - 1)
              this.search.datePicker.customInterval = [two, new Date()];
            }
          },
          {
            text: '3 dias',
            onClick: () => {
              let three = new Date();
              three.setDate(three.getDate() - 2)
              this.search.datePicker.customInterval = [three, new Date()];
            }
          },
          {
            text: '5 dias',
            onClick: () => {
              let five = new Date();
              five.setDate(five.getDate() - 4)
              this.search.datePicker.customInterval = [five, new Date()];
            }
          },
          {
            text: '7 dias',
            onClick: () => {
              let seven = new Date();
              seven.setDate(seven.getDate() - 6)
              this.search.datePicker.customInterval = [seven, new Date()];
            }
          },
          {
            text: '15 dias',
            onClick: () => {
              let fifteen = new Date();
              fifteen.setDate(fifteen.getDate() - 14)
              this.search.datePicker.customInterval = [fifteen, new Date()];
            }
          }],
        }
      }
    };
  },

  watch: {
    $route(to) {
      this.agregation = to.params.type
      this.loadData();
      this.loadIndicatorsList();
    },

    filterValue() {
      if (this.filterValue > 0) {
        this.filterFlag = 1;
      } else {
        this.filterFlag = 0;
      }
    },

    // eslint-disable-next-line no-unused-vars
    "nodeSelected.keySelect": function (newKey, old) {
      if (this.nodeSelected.keySelect.split("")[0] == 'O') {
        return
      }

      this.storagedStartDate = JSON.parse(localStorage.getItem("startDate"));
      this.storagedFinalDate = JSON.parse(localStorage.getItem("finalDate"));


      let startCheck = this.checkEmptyStoragedDates(this.storagedStartDate)
      let finalCheck = this.checkEmptyStoragedDates(this.storagedFinalDate)

      let system = localStorage.getItem("system");

      if (this.nodeSelected.keySelect.split("")[1] == 'G') {
        this.startDate = startCheck ? moment().subtract(7, "day") : this.storagedStartDate;
        this.finalDate = finalCheck ? moment() : this.storagedFinalDate;
      }
      else {
        if (system == 'GDI') {
          this.startDate = startCheck ? moment().subtract(1, "day").hour(0).minute(0).seconds(0) : this.storagedStartDate;
          this.finalDate = finalCheck ? moment().subtract(1, "day").hour(23).minute(59).seconds(59) : this.storagedFinalDate;
        }
        else {
          if (this.nodeSelected.indicatorCalcType == 'diario') {
            this.startDate = startCheck ? moment().subtract(7, "day") : this.storagedStartDate;
            this.finalDate = finalCheck ? moment() : this.storagedFinalDate;
          } else {
            this.startDate = startCheck ? moment().subtract(1, "day") : this.storagedStartDate;
            this.finalDate = finalCheck ? moment() : this.storagedFinalDate;
          }
        }
      }

      this.loadData();
    },

    startDate() {
      if (!this.dateIsOk()) return

      localStorage.setItem("startDate", JSON.stringify(this.startDate))

      if (this.compareKPI) {
        if (this.loadtrendCorrelationExecuting == false) {
          this.getTrendCorrelation();
        }
      } else {
        if (this.loadtrendExecuting == false) {
          this.loadData();
        }
      }
    },

    finalDate() {
      if (!this.dateIsOk()) return

      localStorage.setItem("finalDate", JSON.stringify(this.finalDate))

      if (this.compareKPI) {
        if (this.loadtrendCorrelationExecuting == false) {
          this.getTrendCorrelation();
        }
      } else {
        if (this.loadtrendExecuting == false) {
          this.loadData();
        }
      }
    },

    key1() {
      if (!this.key1) {
        this.scaleKey1 = false;
        this.switchKey1Options = true;
      } else {
        this.switchKey1Options = false;
      }
      this.getTrendCorrelation();
    },

    key2() {
      if (!this.key2) {
        this.scaleKey2 = false;
        this.switchKey2Options = true;
      } else {
        this.switchKey2Options = false;
      }
      this.getTrendCorrelation();
    },

    key3() {
      if (!this.key3) {
        this.scaleKey3 = false;
        this.switchKey3Options = true;
      } else {
        this.switchKey3Options = false;
      }
      this.getTrendCorrelation();
    },

    scaleKey1() {
      this.getTrendCorrelation();
    },

    scaleKey2() {
      this.getTrendCorrelation();
    },

    scaleKey3() {
      this.getTrendCorrelation();
    }
  },

  methods: {
    dateIsOk() {
      let start = typeof this.startDate == 'string' ? moment(this.startDate, "DD/MM/YYYY hh:mm:ss") : this.startDate
      let final = typeof this.finalDate == 'string' ? moment(this.finalDate, "DD/MM/YYYY hh:mm:ss") : this.finalDate
      
      if (start > final) {
        showError(this.$t('por-favor-selecione-um-periodo-inicial-menor-que-o-final'))
        return false;
      }
      return true;
    },

    wait(on) {
      let el = document.querySelector(".loadingData");
      if (!el)
        return
      if (on)
        el.style.display = "block";
      else
        el.style.display = "none";
    },

    isGreaterThanHundread() {
      if (this.filterValue > 100) this.filterValue = 100;

      if (this.filterValue < 0) {
        this.filterValue = 0;
      }
    },

    showCompareKPI() {
      this.compareKPI = !this.compareKPI;
      this.getTrendCorrelation();
    },

    filterRenderOption() {
      if (this.filterFlag == 1 && this.filterValue > 0) {
        this.filterValue = 0;
        this.filterFlag = 0;
        this.filterRenderToggle = !this.filterRenderToggle;
        this.loadData();
      } else {
        this.filterRenderToggle = !this.filterRenderToggle;
      }
    },
    loadIndicatorsList() {
      try {
        const url = `${urlMainAPI}/getindicatorlist`;
        axios
          .get(url)
          .then((res) => {
            const uniqueIndicators = res.data.filter((indicator, index, self) =>
              index === self.findIndex((i) => i.indicatorId === indicator.indicatorId)
            );
            
            this.indicators = [...this.indicators, ...uniqueIndicators];
          })
          .catch((error) => {
            console.error(error);
            showError(this.$t('erro-carregando-indicadores'));
          });
      } catch (error) {
        console.error(error);
        showError(this.$t('erro-carregando-indicadores'));
      }
    },

    async loadData(forTime) {
      // Chave de ocorrencia (prefixo 'O') nao tem historico de indicador: nao chama getindicatortrend.
      if (!this.nodeSelected || !this.nodeSelected.keySelect ||
        this.nodeSelected.keySelect.toString().charAt(0) === 'O') return;
      try {
        this.loadtrendExecuting = true;
        let obj = {};
        obj.key = this.nodeSelected.keySelect;
        let t1 = moment(this.startDate, "DD/MM/YYYY HH:mm:ss").clone();
        let t2 = moment(this.finalDate, "DD/MM/YYYY HH:mm:ss").clone();
        t1 = t1.format();

        if (!forTime)
          t2 = t2.format();
        else {
          let now = moment();
          this.finalDate = now.format("DD/MM/YYYY HH:mm:ss")
          t2 = now.format()
        }

        obj.initialTimestamp = t1;
        obj.finalTimestamp = t2;

        obj.filterFlag = this.filterFlag;
        obj.filterValue = this.filterValue;
        obj.agregation = this.agregation;

        defaultSuccess(this.$t('carregando-dados-do-periodo'))
        if (document.querySelector(".loadingData")) {
          this.wait(true)
        }
        const url = `${urlMainAPI}/getindicatortrend`;
        await axios
          .post(url, obj)
          .then((res) => {
            res = res.data;
            if (res.hasData == false) {
              defaultSuccess(this.$t('sem-dados-no-periodo'));
            }else {
              defaultSuccess(this.$t('dados-carregados'));
            }

            this.trend = res.trend;
            this.meanChart = res.meanChart;
            this.ppkChart = res.ppkChart;
            this.reabilityChart = res.reabilityChart;
            this.loadtrendExecuting = false;
            this.loadRtoPeriodos();
            if (document.querySelector(".loadingData")) {
              this.wait(false)
            }
          })
          .catch(e => {
            console.log(e);
            if (document.querySelector(".loadingData")) {
              this.wait(false)
            }
          });
        // eslint-disable-next-line no-empty
      } catch (error) { console.log(error) }
    },

    async ReloadData() {
      // Chave de ocorrencia (prefixo 'O') nao tem historico de indicador: nao chama getindicatortrend.
      if (!this.nodeSelected || !this.nodeSelected.keySelect ||
        this.nodeSelected.keySelect.toString().charAt(0) === 'O') return;
      this.loadtrendExecuting = true;
      const hasLoader = !!document.querySelector('.loadingData');
      if (hasLoader) this.wait(true);    

      try {
        const now = moment();
        const obj = {
          key: this.nodeSelected.keySelect,
          initialTimestamp: now.clone().subtract(8, 'hours').format(),
          finalTimestamp: now.format(),
          filterFlag: this.filterFlag,
          filterValue: this.filterValue,
          agregation: this.agregation
        };

        defaultSuccess(this.$t('carregando-dados-do-periodo'));
        const { data: res } = await axios.post(`${urlMainAPI}/getindicatortrend`, obj);

        if (!res.hasData) defaultSuccess(this.$t('sem-dados-no-periodo'));
        else defaultSuccess(this.$t('dados-carregados'));

        this.trend         = res.trend;
        this.meanChart     = res.meanChart;
        this.ppkChart      = res.ppkChart;
        this.reabilityChart= res.reabilityChart;
        this.loadRtoPeriodos();

      } catch (e) {
        console.error(e);
        showError(this.$t('erro-ao-carregar-dados')); 
      } finally {
        this.loadtrendExecuting = false;
        if (hasLoader) this.wait(false); 
      }
    },

    async getTrendCorrelation() {
      try {
        this.loadtrendCorrelationExecuting = true;

        let obj = {};
        obj.key = this.nodeSelected.keySelect;
        obj.key1 = !this.key1 ? "" : this.key1;
        obj.key2 = !this.key2 ? "" : this.key2;
        obj.key3 = !this.key3 ? "" : this.key3;
        obj.scaleKey1 = this.scaleKey1;
        obj.scaleKey2 = this.scaleKey2;
        obj.scaleKey3 = this.scaleKey3;
        let t1 = moment(this.startDate, "DD/MM/YYYY HH:mm:ss").clone();
        let t2 = moment(this.finalDate, "DD/MM/YYYY HH:mm:ss").clone();
        t1 = t1.format();
        t2 = t2.format();
        obj.initialTimestamp = t1;
        obj.finalTimestamp = t2;
        obj.filterFlag = this.filterFlag;
        obj.filterValue = this.filterValue;
        obj.agregation = this.agregation;
        this.wait(true);
        await axios.post(`${urlMainAPI}/getindicatortrendcorrelation`, obj).then((res) => {
          res = res.data;
          if (res.hasData == false) {
            defaultSuccess(this.$t('sem-dados-no-periodo'));
          }
          this.trendKPICorrelation = res.trend;
          this.listValues = res.listValues;
          this.trendKPICorrelation.series.listValues = res.listValues;
          this.loadtrendCorrelationExecuting = false;
        }).catch(console.error);
      } catch (error) {
        console.error(error)
      }
      this.wait(false);
    },
    async loadRtoPeriodos() {
      if (!this.user?.Permissions?.rtoconfigurar?.allowed) {
        this.applyRtoAnnotations({ ativos: [], inativos: [] });
        return;
      }
      try {
        // startDate/finalDate podem chegar como Moment (do created()) OU string ISO
        // (do localStorage). Trata os dois casos sem assumir formato fixo.
        const toIso = (v) => {
          if (!v) return null;
          if (moment.isMoment(v)) return v.isValid() ? v.format() : null;
          const m = moment(v, [moment.ISO_8601, 'DD/MM/YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm:ss'], true);
          if (m.isValid()) return m.format();
          const fallback = moment(v);
          return fallback.isValid() ? fallback.format() : null;
        };
        const from = toIso(this.startDate);
        const to = toIso(this.finalDate);
        if (!from || !to || from >= to) {
          this.applyRtoAnnotations({ ativos: [], inativos: [] });
          return;
        }
        // validateStatus: () => true evita o axios disparar exceção em 4xx —
        // qualquer erro no endpoint vira "sem períodos" sem toast vermelho.
        const res = await axios.get(`${urlMainAPI}/configurator/rto/periodos`, {
          params: { from, to },
          validateStatus: () => true,
        });
        if (res.status >= 200 && res.status < 300 && res.data && Array.isArray(res.data.ativos)) {
          this.applyRtoAnnotations(res.data);
        } else {
          this.applyRtoAnnotations({ ativos: [], inativos: [] });
        }
      } catch (e) {
        this.applyRtoAnnotations({ ativos: [], inativos: [] });
      }
    },

    onTrendMouseLeave() {
      this.rtoTooltip.visible = false;
    },

    applyRtoAnnotations(periodos) {
      const toMs = (s) => new Date(s).getTime();
      const ativosList   = periodos && periodos.ativos   ? periodos.ativos   : [];
      const inativosList = periodos && periodos.inativos ? periodos.inativos : [];
      this.rtoPeriodLines = ativosList.map(p => ({ name: p.nome || 'RTO Ativo', startMs: toMs(p.inicio) }));
      this.rtoInativoBands = inativosList.map(p => ({ name: 'Período com RTO Inativo', startMs: toMs(p.inicio), endMs: toMs(p.fim) }));
      const ativos = ativosList.map(p => ({
        x: toMs(p.inicio),
        borderColor: '#f97316',
        strokeDashArray: 0,
        label: { text: '' },
      }));
      const inativos = inativosList.map(p => ({
        x: toMs(p.inicio),
        x2: toMs(p.fim),
        fillColor: '#9ca3af',
        opacity: 0.25,
        borderColor: 'transparent',
        label: { text: '' },
      }));
      this.chartOptions1 = {
        ...this.chartOptions1,
        annotations: {
          yaxis: (this.chartOptions1.annotations && this.chartOptions1.annotations.yaxis) || [],
          xaxis: [...inativos, ...ativos],
        },
      };
    },

    checkEmptyStoragedDates(date){
      if(date == null || date == undefined || date == "Data inválida" || date == "Invalid Date" || date == "" || date == "null" || date == "undefined" ){
        return true
      }

      return false
    },

    onClick_Search() {
      if(
        this.search.datePicker.customInterval.length === 2 
        && this.search.datePicker.customInterval[0] 
        && this.search.datePicker.customInterval[1]
      ) {
        this.startDate = moment(this.search.datePicker.customInterval[0])
        this.finalDate = moment(this.search.datePicker.customInterval[1])
      }
    }
  },
  created() {
    this.storagedStartDate = JSON.parse(localStorage.getItem("startDate"));
    this.storagedFinalDate = JSON.parse(localStorage.getItem("finalDate"));

    let startCheck = this.checkEmptyStoragedDates(this.storagedStartDate)
    let finalCheck = this.checkEmptyStoragedDates(this.storagedFinalDate)

    that = this;
    this.agregation = this.$route.params.type;

    let system = localStorage.getItem("system");

    if (this.nodeSelected.keySelect.split("")[1] == 'G') {
      this.startDate = startCheck ? moment().subtract(7, "day") : this.storagedStartDate;
      this.finalDate = finalCheck ? moment() : this.storagedFinalDate;
    }
    else {
      if (system == 'GDI') {
        this.startDate = startCheck ? moment().subtract(1, "day").hour(0).minute(0).seconds(0) : this.storagedStartDate;
        this.finalDate = finalCheck ? moment().subtract(1, "day").hour(23).minute(59).seconds(59) : this.storagedFinalDate;
      }
      else {
        if (this.nodeSelected.indicatorCalcType == 'diario') {
          this.startDate = startCheck ? moment().subtract(7, "day") : this.storagedStartDate;
          this.finalDate = finalCheck ? moment() : this.storagedFinalDate;
        } else {
          this.startDate = startCheck ? moment().subtract(1, "day") : this.storagedStartDate;
          this.finalDate = finalCheck ? moment() : this.storagedFinalDate;
        }
      }
    }
    this.loadData();
    this.loadIndicatorsList();
  },
  destroyed() {
    delete localStorage.startDate
    delete localStorage.finalDate
    that = null;
    this.wait(false);
    this.modalOpen = false;
  },
};
</script>

<style scoped>
.modalContent {
  height: 320px;
  margin-right: 40px;
}

.loadingData {
  position: absolute;
  top: 49.5px;
  right: 0px;
  width: 100%;
  height: 257.5px;
  background-color: #bbb3;
  border-radius: 3px;
  z-index: 5;
  transition-duration: 900ms;
}

.gridColumns {
  margin-top: 15px;
  max-height: 250px;
  justify-content: center;
}

.gridGraphStyle1 {
  display: grid;
  grid-template-columns: 200px 200px 200px 5fr;
}

.comboboxField {
  grid-column: 1/4;
}

.comboHeader {
  display: flex;
  justify-content: space-between;
}

.gridGraphStyle2 {
  display: grid;
  grid-template-columns: 200px 200px 200px 5fr;
}

#filterRender {
  width: 85px;
  height: 25px;
  margin: 0px 10px;
}

.filterLabel {
  font-size: 0.9em;
}

.filterBt {
  width: 40px;
  height: 25px;
  font-size: 0.8em;
  margin: auto auto;
  padding: 0px;
  background-color: #179e91;
}

.modalHeader {
  min-width: 1250px;
}

.filterGroup {
  display: flex;
  align-items: center;
  margin-right: 20px;
  border: 1px #ced4da solid;
  height: 34px;
  padding: 0px 5px;
}

.trendPosition {
  min-width: 700px;
}

.rto-trend-wrapper {
  position: relative;
}

.rto-period-tooltip {
  position: absolute;
  top: 4px;
  transform: translateX(-50%);
  background: #f97316;
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 3px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.dataPickersGroupContent {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 10px;
}

.spaceBetween {
  padding-right: 10px;
}

.float-right {
  cursor: pointer;
}

.adjustDatePickers {
  width: 180px;
  height: 25px;
  margin-right: 5px;
}

img {
  max-height: 45px;
}

.titleGraph {
  font-size: 16pt;
  font-weight: bold;
}

.mobile-mode {
  display: none;
}

.datepicker-input-group input[type="text"]:not(:placeholder-shown) {
  background-color: #ff5f00;
  color: #ffffff;
  font-weight: 600;
}

@media only screen and (max-width: 1199px) {
  .modalContent {
    overflow-x: scroll;
    min-height: 340px;
  }

  .mobile-mode {
    display: inline-block;
    min-width: 1300px;
    margin: 0;
  }
}

@media only screen and (max-width: 576px) {
  .titleGraph {
    font-size: 14pt;
  }
}
</style>
